import { Component, Inject, OnInit } from '@angular/core';
import { NoiseAbatementService } from '../service/noise-abatement.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditNoiseAbatementComponent } from '../edit-noise-abatement/edit-noise-abatement.component';


@Component({
  selector: 'app-delete-noise-abatement',
  templateUrl: './delete-noise-abatement.component.html',
  styleUrls: ['./delete-noise-abatement.component.scss']
})
export class DeleteNoiseAbatementComponent implements OnInit {
  noiseId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditNoiseAbatementComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _noiseAbatementService: NoiseAbatementService) {
    this.noiseId = data.noiseId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._noiseAbatementService.deleteNoiseAbatement(this.airportId, this.noiseId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
